/**
 * ProofPanel — Dynamic Output mock for "Why should I trust this
 * studio?" Rev 25.6 Loop F now reads the projects + uptime numbers
 * from /v1/public/stats; "Systems shipped" + "Avg uptime maintained"
 * are live values. LCP + Avg-review are still mock for now.
 */

import { useEffect, useState } from "react";
import { fetchStats } from "../../lib/stats";

type Stat = { value: string; suffix: string; label: string };

const MOCK_STATS: Stat[] = [
  { value: "120", suffix: "+", label: "Systems shipped" },
  { value: "99.98", suffix: "%", label: "Avg uptime maintained" },
  { value: "<2.5", suffix: "s", label: "LCP on every page" },
  { value: "4.9", suffix: "/5", label: "Avg client review" },
];

export function ProofPanel() {
  // Rev 25.6.2 — floor retired; projects is owner-configurable via
  // admin Settings now, so the displayed value matches whatever the
  // owner saved most recently.
  const [stats, setStats] = useState<Stat[]>(MOCK_STATS);
  useEffect(() => {
    let alive = true;
    fetchStats().then((live) => {
      if (!alive) return;
      setStats([
        { value: String(live.projects), suffix: "+", label: "Systems shipped" },
        { value: live.uptime.replace(/%$/, ""), suffix: "%", label: "Avg uptime maintained" },
        { value: "<2.5", suffix: "s", label: "LCP on every page" },
        { value: "4.9", suffix: "/5", label: "Avg client review" },
      ]);
    });
    return () => { alive = false; };
  }, []);
  const STATS = stats;
  return (
    <div className="grid gap-3">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {STATS.map((s) => (
          <div
            key={s.label}
            className="rounded-nx2 border border-nx-line bg-nx-surface/60 p-3.5"
          >
            <div className="flex items-baseline gap-0.5">
              <span className="font-display text-3xl font-semibold leading-none tracking-tight text-nx-text">
                {s.value}
              </span>
              <span className="font-display text-base font-semibold text-nx-accent">
                {s.suffix}
              </span>
            </div>
            <div className="mt-1.5 font-mono text-[10.5px] uppercase tracking-[0.14em] text-nx-text-faint">
              {s.label}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-nx2 border border-nx-line bg-nx-surface/60 p-4">
        <div className="flex flex-wrap items-baseline justify-between gap-2">
          <h4 className="font-display text-base font-semibold text-nx-text">
            Senior engineers. AWS-native end-to-end. Every project, an architect on review.
          </h4>
          <span className="inline-flex items-center gap-1.5 font-mono text-[10.5px] uppercase tracking-[0.14em] text-nx-text-faint">
            <span
              className="inline-block h-1.5 w-2.5"
              style={{ background: "#34D399" }}
              aria-hidden
            />
            still in production
          </span>
        </div>
        <p className="mt-2 text-[13px] leading-relaxed text-nx-text-dim">
          NEXIRT is led by Newton Cazzaro (founder + lead architect) with a
          small senior bench of engineers and architects. Every project gets
          a primary engineer plus an architect reviewer — no PM telephone,
          no offshore round-trip. The engineer you scope with is the
          engineer who answers the pager.
        </p>
      </div>
    </div>
  );
}

export default ProofPanel;
